import { ORG_PRODUCTS_TAB_ES_MX } from "./products-tab";
import { ORG_PRODUCTS_CATEGORIES_ES_MX } from "./categories";
import { OrgProductsTranslations } from "#i18n/translations/pt-BR/org/products";

export const ORG_PRODUCTS_ES_MX: OrgProductsTranslations = {
	tabs: {
		productsTab: ORG_PRODUCTS_TAB_ES_MX,
		categories: ORG_PRODUCTS_CATEGORIES_ES_MX,
		generalStock: "Stock General",
	},
	functions: {
		modal: {
			sheet: {
				inventory: "inventario",
				columns: {
					id: "Id del producto",
					name: "Nombre",
					category: "Categoría",
					type: "Tipo de producto",
					hasAlcohol: "¿Contiene alcohol?",
					fiscalCode: "SKU",
					fiscalNcm: "Fiscal - NCM",
				},
			},
		},
	},
	emptyList: "Ningún producto encontrado",
};
